import requests from '../../../requests'

export default {
  list () {
    return requests.get('logistics/transport/vehicles')
  },
  get (id) {
    return requests.get(`logistics/transport/vehicles/${id}`)
  },
  create (o) {
    return requests.post('logistics/transport/vehicles', o)
  },
  update (o) {
    return requests.put(`logistics/transport/vehicles/${o.id}`, o)
  },
  delete (o) {
    return requests.delete(`logistics/transport/vehicles/${o.id}`)
  }
}
